<script>
export default {
  props: {
    completed: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    itemsChecklists: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: "#ef476f",
    },
    position: {
      type: String,
      default: "right",
    },
    size: {
      type: String,
      default: "lg",
    },
    mode: {
      type: String,
      default: "checklists",
    },
  },
  data() {
    return {
      value: "0%",
    };
  },
  mounted() {
    this.updateValue();
  },
  watch: {
    itemsChecklists: {
      handler: "updateValue",
      deep: true,
      immediate: true,
    },
    completed: {
      handler: "updateValue",
      immediate: true,
    },
    total: {
      handler: "updateValue",
      immediate: true,
    },
    mode: {
      handler: "updateValue",
      immediate: true,
    },
    value(newValue) {
      // Emitir el progreso calculado
      this.$emit("progress-updated", parseFloat(newValue));
    },
  },
  methods: {
    updateValue() {
      let total = 0;
      let completed = 0;

      if (this.mode === "checklists") {
        if (this.itemsChecklists.length) {
          this.itemsChecklists.forEach((item) => {
            total += 1;
            if (item.isDone) completed += 1;
            if (item.subItems && item.subItems.length > 0) {
              total += item.subItems.length;
              completed += item.subItems.filter(
                (subItem) => subItem.isDone
              ).length;
            }
          });
        }
      } else if (this.mode === "cards") {
        total = this.total;
        completed = this.completed;
      }

      // Calcular el progreso
      const result = total > 0 ? (completed / total) * 100 : 0;
      this.value = result.toFixed(2) + "%";
    },
  },
};
</script>

<template>
  <div class="progress-container" :class="[position, size]">
    <div class="progress-label">
      {{ value }}
    </div>
    <div class="progress-track">
      <div
        class="progress-fill"
        :style="{
          width: value,
          background: `linear-gradient(90deg, ${color} 0%, ${color}dd 100%)`,
        }"
      ></div>
      <div
        class="progress-glow"
        :style="{
          width: value,
          background: `linear-gradient(90deg, ${color}40 0%, transparent 100%)`,
        }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
.progress-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
}

.progress-container.left {
  flex-direction: row-reverse;
}

.progress-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-muted);
  min-width: 3rem;
  text-align: right;
  transition: color 0.3s ease;
}

.progress-container.left .progress-label {
  text-align: left;
}

.progress-track {
  position: relative;
  flex: 1;
  height: 6px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.dark .progress-track {
  background: rgba(255, 255, 255, 0.08);
}

.progress-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 12px;
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.progress-glow {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 12px;
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  filter: blur(8px);
  opacity: 0.6;
}

/* Tamaños */
.progress-container.sm .progress-track {
  height: 4px;
}

.progress-container.sm .progress-label {
  font-size: 0.7rem;
}

.progress-container.md .progress-track {
  height: 5px;
}

.progress-container.md .progress-label {
  font-size: 0.72rem;
}

.progress-container.lg .progress-track {
  height: 6px;
}

.progress-container.lg .progress-label {
  font-size: 0.75rem;
}

/* Animación de entrada */
.progress-fill {
  animation: progressSlideIn 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes progressSlideIn {
  from {
    width: 0%;
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Efecto hover sutil */
.progress-track:hover .progress-fill {
  filter: brightness(1.1);
  transition: filter 0.2s ease;
}
</style>
